export default __webpack_public_path__ + "static/media/d_products.7b42a870.png";